import React, { Component } from 'react';
import { themr } from 'react-css-themr';
import classnames from 'classnames';
import PropTypes from 'prop-types';

class CardList extends Component {
    static propTypes = {
        children: PropTypes.any,
        className: PropTypes.string,
        raised: PropTypes.bool,
        theme: PropTypes.shape({
            card: PropTypes.string,
            raised: PropTypes.string
        })
    };

    render() {
        const {
            children,
            className,
            theme,
            clickTargetRef,
            ...other
        } = this.props;
        const classes = classnames(
            theme.cardList,
            {
                [theme.selectable]: true && theme.selectable
            },
            className
        );
        return (
            <div
                data-react-toolbox="card-list"
                className={classes}
                {...other}
                ref={clickTargetRef}
            >
                {children}
            </div>
        );
    }
}

export default themr('MLCardList')(CardList);
export { CardList };
